module.exports = __webpack_public_path__ + "static/media/backIcon.5b59544b.svg";